import { Component, Input } from '@angular/core';
import { Auth, OpnOfferEvaluationMethodModel, TranslationManager, ViewState } from 'src/common';
import { OpnElementViewModel } from '../../opn-steps-elements.model';

@Component({
	selector: 'opn-offer-evaluation-method-elements',
	templateUrl: './opn-offer-evaluation-method-elements.component.html'
})
export class OpnOfferEvaluationMethodElementsComponent {

	elements: OpnElementViewModel[] = [];
	translationManager = TranslationManager;
	@Input() state: ViewState;
	viewState = ViewState;
  auth = Auth;


	addOfferEvaluationMethodElement() {
		let element: OpnElementViewModel = this.createElement();
		element.element = new OpnOfferEvaluationMethodModel();
		this.elements.push(element);
	}

	private createElement(): OpnElementViewModel {
		let element: OpnElementViewModel = new OpnElementViewModel();
		element.delete = this.deleteElement.bind(this);
		return element;
	}

	getElements(): OpnOfferEvaluationMethodModel[] {
		let elements: OpnOfferEvaluationMethodModel[] = [];

		if (this.elements) {
			this.elements.forEach(s => {
				elements.push(s.getElement());
			})
		}

		return elements;
	}

  deleteAll() {
		this.elements.splice(0, this.elements.length);
	}

	deleteElement(model: OpnElementViewModel) {
		this.elements.splice(this.elements.indexOf(model), 1);
	}

	isValid(): boolean {
		let isValid: boolean = true;

		this.elements.forEach(s => {
			isValid = s.isValid() && isValid;
		})

		return isValid;
	}
}
